import styled from 'styled-components'

const TabContainer = styled.div`
  width: 100%;
  padding: 2rem 3rem;
`

export default TabContainer
